module.exports = __webpack_public_path__ + "img/ring_g_i_0_null@3x.e11e095a.png";